import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';
import {textStart} from '~/actions/AnalyticsActions';
import {getSelectedIconsArray} from '~/selectors/CanvasSelectors';
import {
  allowsNamesAndNumbers,
  getErrorFreeSelectedProduct
} from '~/selectors/ProductSelectors';

export const select = () => {
  return createStructuredSelector({
    allowsNamesAndNumbers,
    selectedIcons: getSelectedIconsArray,
    currentProduct: getErrorFreeSelectedProduct
  });
};

export const actions = dispatch => {
  return {
    analytics: {
      textStart: bindActionCreators(textStart, dispatch)
    }
  };
};
